export default __webpack_public_path__ + "static/media/loader-transp-final.18240c53.gif";